import { useState } from 'react';
import { createStore } from 'reusable';

export const useIsCreateNewWalletModalIsOpen = createStore(() =>
  useState(false)
);
